import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api, errMsg } from "../lib/api";
import { LangSwitch, useLang } from "../lib/i18n";

export default function ResetPassword() {
  const { t } = useLang();
  const [params] = useSearchParams();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) return setError(t("reset.mismatch"));
    setBusy(true);
    setError("");
    try { await api.post("/auth/reset-password", { token: params.get("token") || "", password: pw }); setDone(true); } catch (err) { setError(errMsg(err)); }
    setBusy(false);
  };
  return (
    <div className="min-h-screen grid place-items-center p-6">
      <form onSubmit={submit} className="tl-card w-full max-w-md space-y-4" data-testid="reset-form">
        <div className="flex items-center justify-between"><h1 className="text-3xl font-bold uppercase">{t("reset.title")}</h1><LangSwitch dark /></div>
        {done ? (
          <>
            <p className="text-sm text-emerald-700" data-testid="reset-done">{t("reset.done")}</p>
            <Link to="/login" className="tl-btn tl-btn-primary w-full" data-testid="reset-back-login">{t("login.submit")}</Link>
          </>
        ) : (
          <>
            <label className="block"><span className="tl-label">{t("reset.new")}</span><input className="tl-input" type="password" minLength={8} required value={pw} onChange={(e) => setPw(e.target.value)} data-testid="reset-password-input" /></label>
            <label className="block"><span className="tl-label">{t("reset.confirm")}</span><input className="tl-input" type="password" minLength={8} required value={pw2} onChange={(e) => setPw2(e.target.value)} data-testid="reset-password-confirm" /></label>
            {error && <div className="text-sm text-red-700 bg-red-50 border border-red-200 rounded-lg p-3" data-testid="reset-error">{error}</div>}
            <button className="tl-btn tl-btn-primary w-full" disabled={busy} data-testid="reset-submit">{busy && <Loader2 className="animate-spin" size={16} />} {t("reset.submit")}</button>
          </>
        )}
      </form>
    </div>
  );
}
